export default __webpack_public_path__ + "static/media/global.5905c331.mp4";